import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import './sections.scss'
import {ConvertToJalali, RewardsData} from "../../StoreDetail/StoreDetailServices";
import SwiperId from "react-id-swiper";
import SimpleLineIcon from "react-simple-line-icons";

const RewardList = ({item}) =>{

    //vars
    const [rewards,setRewards] = useState([])


    const params = {
        slidesPerView: 'auto',
        spaceBetween: 20,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        breakpoints: {
            1024: {
                slidesPerView: 'auto',
                spaceBetween: 40
            },
            768: {
                slidesPerView: 'auto',
                spaceBetween: 30
            },
            400: {
                slidesPerView: 'auto',
                spaceBetween: 20
            },
            320: {
                slidesPerView: 1,
                spaceBetween: 10
            }
        }
    }



    // Fetch Festivals And Rewards ---------------------------------------------
    const getRewards = async (merchantId) => {
        try{
            let response = await RewardsData(merchantId);
            console.log("Rewards : ", response.data)
            let rewards = response.data.filter(item=>{
                return item.generated_coupon
            })
            setRewards(rewards);
        }catch (e) {
            console.log(e)
        }
    }


    useEffect(()=>{
        getRewards(item.mall_uid)
    },[])

    return(
        <div className="RewardList-container" style={{margin: "20px 16px 0 16px"}}>
            {item.title?<div className="section-title"><span>{item.title}</span></div>:null}
            {/*Reward*/}
            <div className="storeDetail-rewards">

                {rewards && rewards.length>0?<div className="storeDetail-reward-titre">
                    پاداش ها
                </div>:null}
                {rewards.length>0?<SwiperId {...params}>
                    {rewards.map(reward=>{
                        return(
                            <div key={reward.uid} className="slider-gift-section">
                                <div className="gift-section-ticket">
                                    <div className="gift-section-ticket-off reward_level_2">
                                        <span className="gift-section-ticket-off-number"><span className="off-number">{reward.generated_coupon.discount_value>100?100:reward.generated_coupon.discount_value}</span>%</span>
                                        <span className="gift-section-ticket-off-label">تخفیف</span>
                                    </div>
                                    <div className="gift-section-ticket-info">
                                        <div className="rotated-half-up-circle"></div>
                                        <div className="rotated-half-down-circle"></div>
                                        <span className="gift-section-ticket-info-title">{reward.generated_coupon.title}</span>
                                        <span className="gift-section-ticket-info-max">{`تا سقف ${parseInt(reward.generated_coupon.max_discount_amount/10)}  ریال`}</span>
                                        <div className="gift-section-ticket-info-date">
                                            <span>{ConvertToJalali(reward.generated_coupon.valid_to_date)}</span>
                                            <SimpleLineIcon name="clock" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </SwiperId>:null}

            </div>
        </div>
    )
}

export {RewardList}
